 <template>
    <el-drawer class="w-el-drawer" :visible.sync="visible" :size="960" :with-header="false" direction="rtl" :before-close="Close" append-to-body destroy-on-close>
        <div class="w-el-drawer-header">
            <i class="el-icon-tickets"></i> 新的商机
        </div>
        <div class="w-el-drawer-body"  v-loading="loading">
            <el-form :model="form" label-width="120px" size="mini">
                <el-form-item label="商机主题" :rules="[{ required: true, message: '必填项' }]" :error="formError.name?.toString()" prop="name">
                    <el-input v-model="form.name" placeholder="客户名称+项目名称" clearable />
                </el-form-item>
                <el-form-item :rules="[{ required: true, message: '必填项' }]" label="关联客户" :error="formError.customer_id?.toString()" prop="customer_id">
                    <crm-customer-select v-model="form.customer_id" clearable />
                </el-form-item>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="项目来源" :rules="[{ required: true, message: '请选择项目来源,最多填入16个字符' }]" :error="formError.source_id?.toString()" prop="source_id">
                            <inputSource v-model="form.source_id"></inputSource>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工作流程" :rules="[{ required: true, message: '请选择项目来源,最多填入16个字符' }]" :error="formError.progress_id?.toString()" prop="progress_id">
                            <crm-business-progress-select v-model="form.progress_id" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider content-position="left">参与成员</el-divider>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必选项' }]" label="商务" :error="formError.user_affair_id?.toString()" prop="user_affair_id">
                            <users-select v-model="form.user_affair_id" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必选项' }]" label="销售" :error="formError.user_sale_id?.toString()" prop="user_sale_id">
                            <users-select v-model="form.user_sale_id" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必选项' }]" label="售前" :error="formError.user_presale_id?.toString()" prop="user_presale_id">
                            <users-select v-model="form.user_presale_id" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必选项' }]" label="管理员" :error="formError.user_admin_id?.toString()" prop="user_admin_id">
                            <users-select v-model="form.user_admin_id" disabled />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
<!--                    <el-form-item :rules="[{ required: true, message: '必选项' }]" label="成本确认人" :error="formError.user_cost_confirming_id?.toString()" prop="user_cost_confirming_id">-->
<!--                      <users-select v-model="form.user_admin_id" />-->
<!--                    </el-form-item>-->
                      <el-form-item  label="实施部门" :error="formError.user_cost_confirm_id?.toString()" prop="user_cost_confirm_id">
                        <el-select v-model="form.user_cost_confirm_id" placeholder="请选择实施部门" clearable size="mini">
                          <el-option label="创新中心" value="159"></el-option>
                          <el-option label="运营中心" value="5"></el-option>
                        </el-select>
                      </el-form-item>
                  </el-col>
                </el-row>
                
                <el-divider content-position="left">成本预估</el-divider>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="预估总成本" :error="formError.estimate_money?.toString()" prop="estimate_money">
                            <el-input-number v-model="form.estimate_money" :min="0" :precision="2" disabled class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="预估工时" :error="formError.estimate_work_day?.toString()" prop="estimate_work_day">
                            <el-input-number v-model="form.estimate_work_day" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="人工成本" :error="formError.estimate_labor?.toString()" prop="estimate_labor">
                            <el-input-number v-model="form.estimate_labor" :min="0" :precision="2" disabled class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>      
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="采购金额" :error="formError.estimate_procurement?.toString()" prop="estimate_procurement">
                            <el-input-number v-model="form.estimate_procurement" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="外采金额" :error="formError.sign_money_sw?.toString()" prop="sign_money_sw">
                            <el-input-number v-model="form.sign_money_sw" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="驻点费用" :error="formError.estimate_stationing?.toString()" prop="estimate_stationing">
                            <el-input-number v-model="form.estimate_stationing" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="其他金额" :error="formError.estimate_other?.toString()" prop="estimate_other">
                            <el-input-number v-model="form.estimate_other" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item  
                            :rules="[{ required: true, message: '必填项' }]" 
                            label="税率 / %"
                            :error="formError.taxation_rate?.toString()" 
                            prop="taxation_rate">
                            <el-select v-model="form.taxation_rate" placeholder="请选择税率" class="w-width-auto">
                            <el-option label="0" :value="0"></el-option>
                            <el-option label="1" :value="1"></el-option>
                            <el-option label="3" :value="3"></el-option>
                            <el-option label="6" :value="6"></el-option>
                            <el-option label="9" :value="9"></el-option>
                            <el-option label="13" :value="13"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="税金" :error="formError.taxation_money?.toString()" prop="taxation_money">
                            <el-input-number v-model="form.taxation_money" :min="0" :precision="2" disabled class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider content-position="left">项目预期金额</el-divider>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="预期总金额" :error="formError.sign_money?.toString()" prop="sign_money">
                            <el-input-number v-model="form.sign_money" :min="0" :precision="2" disabled class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="开发金额" :error="formError.sign_money_kf?.toString()" prop="sign_money_kf">
                            <el-input-number v-model="form.sign_money_kf" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="集成金额" :error="formError.sign_money_jc?.toString()" prop="sign_money_jc">
                            <el-input-number v-model="form.sign_money_jc" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="运维金额" :error="formError.sign_money_yw?.toString()" prop="sign_money_yw">
                            <el-input-number v-model="form.sign_money_yw" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="安服金额" :error="formError.sign_money_af?.toString()" prop="sign_money_af">
                            <el-input-number v-model="form.sign_money_af" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="工程金额" :error="formError.sign_money_gc?.toString()" prop="sign_money_gc">
                            <el-input-number v-model="form.sign_money_gc" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="设备金额" :error="formError.sign_money_sb?.toString()" prop="sign_money_sb">
                            <el-input-number v-model="form.sign_money_sb" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="过单金额" :error="formError.sign_money_gd?.toString()" prop="sign_money_gd">
                            <el-input-number v-model="form.sign_money_gd" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="其它金额" :error="formError.sign_money_qt?.toString()" prop="sign_money_qt">
                            <el-input-number v-model="form.sign_money_qt" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider content-position="left">其它信息</el-divider>
                <el-form-item label="备注">
                    <froala-editor v-model="form.describe" />
                </el-form-item>
                <el-form-item label="抄送对象">
                    <users-select v-model="form.notify_users_id" multiple />
                </el-form-item>
                <el-form-item label="附件">
                    <files-upload v-model="form.files_id" model="saleDocumentary" stage="创建跟单" />
                </el-form-item>
            </el-form>
        </div>
        <div class="w-el-drawer-footer">
            <el-button size="medium" @click="Close()">取消 / 返回</el-button>
            <el-button size="medium" type="primary" @click="FormSubmit()" :loading="loading">确 定</el-button>
        </div>
    </el-drawer>
</template>
<script>
import inputSource from "@/views/config/contractSource/input"
export default {
    components: {
        inputSource,
    },
    data() {
        return {
            visible: false,
            loading: false,
            formError: {},
            form: {
                name: null,
                customer_id: null,
                source_id: null,
                progress_id: null,
                user_affair_id: null,
                user_presale_id: null,
                user_sale_id: null,
                user_admin_id: null,
                estimate_work_day: 0,
                estimate_money: 0,
                estimate_labor: 0,
                estimate_procurement: 0,
                estimate_stationing: 0,
                estimate_other: 0,
                taxation_rate: 0,
                taxation_money: 0,
                sign_money: 0,
                sign_money_jc: 0,
                sign_money_yw: 0,
                sign_money_af: 0,
                sign_money_gc: 0,
                sign_money_sb: 0,
                sign_money_kf: 0,
                sign_money_gd: 0,
                sign_money_qt: 0,
                sign_money_sw: 0,
                describe: null,
                notify_users_id: null,
                files_id: [],
                user_cost_confirming_id:null,
            }
        }
    },
    watch: {
        'form.sign_money_jc' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_yw' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_af' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_gc' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_sb' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_kf' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_gd' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_qt' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money' () {this.CountTaxationRate()},  

        'form.estimate_procurement' () { this.CountTaxationRate(), this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.sign_money_sw' () { this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.estimate_stationing' () { this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.estimate_other' () { this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.estimate_labor' () { this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.taxation_money' () { this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.taxation_rate' () {this.CountTaxationRate()},
        'form.estimate_work_day' () { this.form.estimate_labor = this.form.estimate_work_day * 550},
    },
    methods: {
        Open() {
            this.visible = true
            this.loading = false
            this.formError = {}
            this.form.name = null
            this.form.customer_id = null
            this.form.source_id = null
            this.form.progress_id = null
            this.form.user_affair_id = null
            this.form.user_presale_id = null
            this.form.user_sale_id = null
            this.form.user_admin_id = this.$store.state.user.id
            this.form.estimate_work_day = 0
            this.form.estimate_money = 0
            this.form.estimate_labor = 0
            this.form.estimate_procurement = 0
            this.form.estimate_stationing = 0
            this.form.estimate_other = 0
            this.form.taxation_rate = 0
            this.form.taxation_money = 0
            this.form.sign_money = 0
            this.form.sign_money_jc = 0
            this.form.sign_money_yw = 0
            this.form.sign_money_af = 0
            this.form.sign_money_gc = 0
            this.form.sign_money_sb = 0
            this.form.sign_money_kf = 0
            this.form.sign_money_gd = 0
            this.form.sign_money_qt = 0
            this.form.sign_money_sw = 0
            this.form.describe = null
            this.form.notify_users_id = null
            this.form.files_id = null
        },
        Close() {
            this.visible = false
            this.loading = false
        },
        FormSubmit() {
                        this.loading = true
            this.formError = {}
            this.$http.post('/9api/sale-documentary/create', this.form).then(rps => {
                this.loading = false
                if (rps.data.state == 'error') {
                    this.formError = rps.data.body
                }
                if (rps.data.state == 'success') {
                    this.$notify.success({title: '提示', message: '添加成功', duration: 2000})
                    this.$emit('success', rps.data.body)
                    this.Close()
                }
            })
        },

        // 计算税金 mos+
        CountTaxationRate(){
            // (项目预期总金额-采购成本) / (1+税率) * 税率 * 1.12 + (项目预期总金额+采购成本) * 0.0003
            //注：1%的税率等于数字0.01 、 0.0003 = 0.03% （印花税）
            if(['1.00','3.00'].includes(this.form.taxation_rate)){
                this.form.taxation_money = (this.form.sign_money-this.form.estimate_procurement) / (1 + this.form.taxation_rate * 0.01) * (this.form.taxation_rate * 0.01) * 1.12 + (this.form.sign_money+this.form.estimate_procurement) * 0.0003
            }else if(['6.00','9.00','13.00'].includes(this.form.taxation_rate)){
                this.form.taxation_money = (this.form.sign_money-this.form.estimate_procurement) / (1 + this.form.taxation_rate * 0.01) * (this.form.taxation_rate * 0.01) * 1.12 + (this.form.sign_money+this.form.estimate_procurement) * 0.0003
            }else{
                this.form.taxation_money = (this.form.sign_money-this.form.estimate_procurement) / (1 + this.form.taxation_rate * 0.01) * (this.form.taxation_rate * 0.01) * 1.12 + (this.form.sign_money+this.form.estimate_procurement) * 0.0003
            }
        },
    }
}
</script>